import {
  GiftCardFragment,
  MultiCurrencyPriceFragment,
  PriceSummaryFragment,
  SubscriptionChargesFragment,
} from '../../../../gql/graphql';
import {PriceModel} from '../Price.model';
import {ModelContext} from '../../../../types/checkoutApp.types';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';
import {GiftCardSummaryModel} from './GiftCardSummary.model';
import {SubscriptionChargeModel} from './SubscriptionChargeModel';
import {SPECS} from '../../../../common/constants';
import {LineItemModel} from '../LineItems/LineItem.model';

export class PaymentSummaryModel {
  public requiresPaymentAfterGiftCard: boolean;
  public totalAfterGiftCards: PriceModel;
  public payNow: PriceModel;
  public payLater?: PriceModel;
  public payAfterFreeTrial?: PriceModel;
  public giftCard?: GiftCardSummaryModel;
  public subscriptionCharges: SubscriptionChargeModel[];
  public subscriptionsProjectionsOld?: string[];

  constructor(params: PaymentSummaryModel) {
    this.requiresPaymentAfterGiftCard = params.requiresPaymentAfterGiftCard;
    this.totalAfterGiftCards = params.totalAfterGiftCards;
    this.payNow = params.payNow;
    this.payLater = params.payLater;
    this.payAfterFreeTrial = params.payAfterFreeTrial;
    this.giftCard = params.giftCard;
    this.subscriptionCharges = params.subscriptionCharges;
    this.subscriptionsProjectionsOld = params.subscriptionsProjectionsOld;
  }

  public static fromCheckoutV1({
    requiresPaymentAfterGiftCard,
    totalAfterGiftCards,
    payNow,
    payLater,
    payAfterFreeTrial,
    giftCard,
    subscriptionCharges,
    lineItems,
    modelContext,
  }: {
    requiresPaymentAfterGiftCard?: boolean | null;
    totalAfterGiftCards?: MultiCurrencyPriceFragment | null;
    payNow?: MultiCurrencyPriceFragment | null;
    payLater?: PriceSummaryFragment | null;
    payAfterFreeTrial?: PriceSummaryFragment | null;
    giftCard?: GiftCardFragment | null;
    subscriptionCharges?: (SubscriptionChargesFragment | null)[] | null;
    lineItems: LineItemModel[];
    modelContext: ModelContext;
  }) {
    return new PaymentSummaryModel({
      requiresPaymentAfterGiftCard: requiresPaymentAfterGiftCard ?? /* istanbul ignore next */ true,
      totalAfterGiftCards: PriceModel.fromCheckoutV1(mapNullToUndefined(totalAfterGiftCards), modelContext),
      payNow: PriceModel.fromCheckoutV1(mapNullToUndefined(payNow), modelContext),
      payLater: payLater ? PriceModel.fromCheckoutV1(payLater.total, modelContext) : undefined,
      payAfterFreeTrial: payAfterFreeTrial
        ? PriceModel.fromCheckoutV1(payAfterFreeTrial.total, modelContext)
        : undefined,
      giftCard: GiftCardSummaryModel.fromCheckoutV1(modelContext, giftCard),
      subscriptionCharges: modelContext.flowAPI.experiments.enabled(
        SPECS.SupportReflectingMultipleSubscriptionProjections
      )
        ? (subscriptionCharges ?? [])
            .map((subscriptionCharge) => SubscriptionChargeModel.fromCheckoutV1(lineItems, subscriptionCharge))
            .filter((subscriptionCharge) => !!subscriptionCharge)
        : [],
      subscriptionsProjectionsOld: subscriptionCharges
        ?.map((subscriptionCharge) => subscriptionCharge?.description)
        ?.filter((projection) => projection !== undefined && projection !== null),
    });
  }
}
